export default "/institutions/renner.svg";